








































































































import { Component, Vue } from 'vue-property-decorator'
import axiosInstance from '@/plugins/axios'
import { showHttpErrorAlert } from '@/plugins/helper'
import dayjs from 'dayjs'
import AppNavDrawer from '@/components/AppNavDrawer.vue'

@Component({
  components: {
    AppNavDrawer
  }
})
export default class PageViewVehicleTypes extends Vue {
  headers = [
    { text: 'ID', value: 'id' },
    { text: 'English name', value: 'nameEn' },
    { text: 'Lao name', value: 'nameLa' },
    { text: 'Created At', value: 'createdAt' },
    { text: 'Active at', value: 'activeAt' },
    { text: '', value: 'action' }
  ]

  items = []
  showAddDialog = false
  showEditDialog = false
  activeItem: any = {}
  isSubmitting = false
  isLoadingItems = false

  created () {
    this.fetchVehicleTypes()
  }

  async fetchVehicleTypes () {
    try {
      this.isLoadingItems = true
      const { data } = await axiosInstance.get('/portal/insurance/vehicle-types')
      this.items = data.data.map((item: any) => {
        return {
          id: item.id,
          nameEn: item.name_en,
          nameLa: item.name_la,
          createdAt: item.created_at,
          activeAt: item.active_at
        }
      })
      this.isLoadingItems = false
    } catch (error) {
      this.isLoadingItems = false
      showHttpErrorAlert(error)
    }
  }

  async handleAddForm () {
    try {
      this.isSubmitting = true
      const now = dayjs().format('YYYY-MM-DD HH:mm:ss')
      await axiosInstance.post('/portal/insurance/vehicle-types', {
        'name_en': this.activeItem.nameEn,
        'name_la': this.activeItem.nameLa,
        'created_at': now,
        'active_at': this.activeItem.isActive ? now : null
      })

      this.isSubmitting = false
      this.showAddDialog = false
      this.fetchVehicleTypes()
    } catch (error) {
      this.isSubmitting = false
      showHttpErrorAlert(error)
    }
  }

  handleEditButtonClick (item: any) {
    this.activeItem = {
      ...item,
      isActive: item.activeAt !== null
    }
    this.showEditDialog = true
  }

  async handleEditForm () {
    try {
      this.isSubmitting = true
      const now = dayjs().format('YYYY-MM-DD HH:mm:ss')
      await axiosInstance.put(`/portal/insurance/vehicle-types/${this.activeItem.id}`, {
        'name_en': this.activeItem.nameEn,
        'name_la': this.activeItem.nameLa,
        'created_at': this.activeItem.createdAt,
        'active_at': this.activeItem.isActive ? now : null
      })

      this.isSubmitting = false
      this.showEditDialog = false
      this.fetchVehicleTypes()
    } catch (error) {
      this.isSubmitting = false
      showHttpErrorAlert(error)
    }
  }
}
